"use strict";

import React from 'react';
import DocumentDesignProofLink from "../../component/DocumentDesignProofLink";
import dateFormat from "dateformat";
import OrderLineItemOptions from "./OrderLineItemOptions";
import Accounting from "accounting";
import {myTimestampToDate} from '../../time';
import isDocumentId from "../../document-designer";

const OrderLineItem = ({item={}}) => {
    return (
        <tr className="" style={{borderBottom: '1px solid #dddddd',}}>
            <td className="line-item-action-col">
                {'\u00A0'}
            </td>
            <td className="line-item-quantity-col">
                {item.qty}
            </td>
            <td className="line-item-description-col">
                <div className="admin__order__line-item__description__row">
                    <span className="label cart__line-item__description__qty-label">{item.qty}</span>
                    <span className="cart__line-item__description__sku-label">Item: #{item.product_id}</span>
                    <a href="#"
                       title={`Details for item ${item.name} Item:{item.product_id}`}
                       className="cart__line-item__description__name">
                        {item.name}
                    </a>
                </div>
                { !!item.pf_document_id && isDocumentId( item.pf_document_id ) &&
                <div className="admin__order__line-item__description__row">
                    <p style={{fontStyle: 'italic'}}>
                        {item.pf_document_description}
                        <DocumentDesignProofLink documentId={item.pf_document_id} username={item.pf_username} />
                        <span style={{display: 'inline-block', margin: 'auto 1rem'}}>{item.pf_document_id}</span>
                    </p>
                    { !!item.pf_approved &&
                    <p className="form__note product-approval__line-item__initials">
                        approved: {item.pf_approved_initials} - {dateFormat(myTimestampToDate(item.pf_approved), 'm/d/yy-h:MMtt')}
                    </p>
                    }
                </div>
                }
                <OrderLineItemOptions lineItemId={item.li_id} className="admin__order__line-item__description__row" />
                { !!item.notes &&
                <div className="admin__order__line-item__description__row">
                    <span>NOTES: {item.notes}</span>
                </div>
                }
            </td>
            <td className="line-item-price-col">
                { !!item.price ? Accounting.formatMoney(item.price) : '\u00A0'}
            </td>
            <td className="line-item-subtotal-col">
                { !!item.subtotal ? Accounting.formatMoney(item.subtotal) : '\u00A0'}
            </td>
            <td className="line-item-extra-charges-col">
                { (!!item.xtra_charges || !!item.adjustments_debit_total)
                    ? Accounting.formatMoney((
                        parseFloat(item.xtra_charges)
                            + parseFloat(item.adjustments_debit_total)
                        ))
                    : '\u00A0'
                }
            </td>
            <td className="line-item-discount-col">
                { (!!item.discount || !!item.adjustments_credit_total)
                    ? Accounting.formatMoney((
                        parseFloat(item.discount)
                        + parseFloat(item.adjustments_credit_total)
                    ))
                    : '\u00A0'
                }
            </td>
            <td className="line-item-total-col">
                { !!item.total ? Accounting.formatMoney(item.total) : '\u00A0'}
            </td>
        </tr>
    );
};

export default OrderLineItem;